import { StyledRow } from "App/global-style";
import { Checkbox } from "Components/Form/Checkbox";
import { AdviceProductChangeType } from "Store/advice/interfaces";
import React from "react";
import { AdviceProductDetailsFormValues } from "../../ProductDetails/FormElements/interfaces";
import { Description } from "../../adviceStyled";
import { OneTimePaymentWrapper } from "./styled";
import { getOneTimePaymentTextDeprecated } from "./utils";

interface Props {
  adviceProductIntroFormValues: AdviceProductDetailsFormValues;
  oneTimePaymentValue: number;
  oneTimePayment: any;
  lang: string;
  handleCustomerChange: (
    changeType: AdviceProductChangeType,
    changeValue: number | boolean,
  ) => void;
}
export const DisabilityOneTimePayment = ({
  adviceProductIntroFormValues,
  oneTimePaymentValue,
  oneTimePayment,
  lang,
  handleCustomerChange,
}: Props): React.ReactElement | null => {
  if (oneTimePaymentValue === 0) {
    return null;
  }

  return (
    <OneTimePaymentWrapper>
      <Description fw={700} size="16px">
        {oneTimePayment.header[lang]}
      </Description>
      <StyledRow className="OneTimePaymentCheckbox">
        <Checkbox
          id="disabilityOneTimePayment"
          name="disabilityOneTimePayment"
          label={getOneTimePaymentTextDeprecated(
            adviceProductIntroFormValues,
            oneTimePaymentValue,
            oneTimePayment,
            lang,
          )}
          onChange={(e) => {
            const selected = e.target.checked;
            handleCustomerChange(
              AdviceProductChangeType.ONE_TIME_PAYMENT_CHECKBOX,
              selected,
            );
          }}
        />
      </StyledRow>
    </OneTimePaymentWrapper>
  );
};
